import type { TranslationKeys } from './en';

const fr: TranslationKeys = {
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    close: 'Fermer',
    search: 'Rechercher',
    filter: 'Filtrer',
    loading: 'Chargement...',
    confirm: 'Êtes-vous sûr ?',
    noResults: 'Aucun résultat',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Envoyer',
    retry: 'Réessayer',
    yes: 'Oui',
    no: 'Non',
  },
  nav: {
    dashboard: 'Tableau de bord',
    notifications: 'Notifications',
    governance: 'Gouvernance',
    training: 'Formation',
    toolMatrix: 'Matrice outils',
    inventory: 'Base d\'outils',
    employees: 'Annuaire équipe',
    settings: 'Paramètres',
    billing: 'Facturation',
    advisor: 'Conseiller',
    portal: 'Portail',
    admin: 'Admin',
  },
  dashboard: {
    title: 'Tableau de bord',
    subtitle: 'Arrêtez de vous perdre dans le désert SaaS. Bienvenue sur Oasix.',
    actions: 'Actions',
    financials: 'Finances',
    knowledge: 'Connaissances',
    governanceTasks: 'Tâches de gouvernance',
    pendingRequests: 'Demandes en attente',
    pendingTraining: 'Formations en attente',
    pendingAccesses: 'Accès en attente',
    totalMonthlySpend: 'Dépense mensuelle totale',
    criticalityBreakdown: 'Outils par criticité',
    toolsTotal: 'outils au total',
    overdue: 'en retard',
  },
  inventory: {
    title: 'Inventaire des outils',
    subtitle: 'Gérez votre liste complète d\'outils, modèles tarifaires et responsables.',
    addTool: 'Ajouter un outil',
    searchPlaceholder: 'Rechercher outils ou tags...',
    noTools: 'Aucun outil. Cliquez sur "Ajouter un outil" pour commencer.',
    toolLimitReached: 'Limite d\'outils atteinte. Passez à un plan supérieur.',
  },
  employees: {
    title: 'Annuaire de l\'équipe',
    subtitle: 'Vos collaborateurs, leurs outils, formations et rôles.',
    addEmployee: 'Ajouter un employé',
    searchPlaceholder: 'Rechercher des employés...',
  },
  governance: {
    title: 'Gouvernance & Renouvellements',
    subtitle: 'Surveillez les renouvellements de contrats et échéances de préavis.',
    addTask: 'Ajouter une tâche',
    complianceTasks: 'Conformité & Tâches',
    calendar: 'Calendrier',
    showMore: 'Voir plus',
  },
  training: {
    title: 'Formation',
    subtitle: 'Suivez les taux de complétion et les scores de compétences.',
    addTraining: 'Ajouter une formation',
    curriculum: 'Curriculum',
    assignedFormations: 'Formations assignées',
  },
  notifications: {
    title: 'Centre de notifications',
    subtitle: 'Examinez les demandes d\'accès et de nouveaux outils.',
    pending: 'En attente',
    all: 'Toutes',
  },
  billing: {
    title: 'Facturation',
    currentPlan: 'Plan actuel',
    trialDaysLeft: '{days} jour(s) restant(s) dans votre essai',
    trialExpired: 'Votre essai a expiré',
    cancelled: 'Votre abonnement a été annulé',
    subscribe: 'S\'abonner',
    upgrade: 'Passer au supérieur',
    downgrade: 'Rétrograder',
    monthly: 'Mensuel',
    annual: 'Annuel',
  },
  settings: {
    title: 'Paramètres',
    currency: 'Devise',
    categories: 'Catégories',
    tags: 'Tags',
    teams: 'Équipes',
    criticalityLevels: 'Niveaux de criticité',
    saveChanges: 'Enregistrer les modifications',
  },
  advisor: {
    title: 'Conseiller Oasix',
    whatCanIHelp: 'Comment puis-je vous aider ?',
    analyzeStack: 'Analyser mon stack',
    findReplacement: 'Trouver un remplacement',
    consolidateTools: 'Consolider les outils',
    findNewTool: 'Trouver un nouvel outil',
    negotiateRenewal: 'Négocier un renouvellement',
    askAnything: 'Poser une question',
    askAdvisor: 'Demander au conseiller',
    analyzing: 'Analyse de votre stack en cours...',
    queriesUsed: '{used}/{included} requêtes utilisées',
    newQuery: 'Nouvelle requête',
  },
  portal: {
    title: 'Mon portail',
    myTools: 'Mes outils',
    myTraining: 'Mes formations',
    requests: 'Demandes',
    ideas: 'Idées',
  },
  features: {
    title: 'Idées & Suggestions',
    suggestIdea: 'Proposer une idée',
    mostVoted: 'Plus votées',
    newest: 'Plus récentes',
    votes: 'votes',
  },
  readOnly: {
    expiredMessage: 'Votre essai a expiré. Vos données sont conservées — abonnez-vous pour retrouver l\'accès.',
    cancelledMessage: 'Votre abonnement a été annulé. Les données sont conservées 90 jours.',
    subscribeNow: 'S\'abonner maintenant',
  },
} as const;

export default fr;
